import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';
import { OPEN_BILLS_MODAL } from '@spotahome/marketplace-common/src/channels';
import {
  Modal,
  ModalBody,
  ModalHeader,
  useModalHandle
} from '@spotahome/ui-library';

import ListingBills from '../ListingPricing/ListingBills';

import './BillsIncludedModal.scss';

const BillsIncludedModal = ({ bills = [], currency, listingType }) => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle();

  useEffect(() => {
    Mediator.subscribe(OPEN_BILLS_MODAL, handleModalOpen);

    return () => Mediator.unsubscribe(OPEN_BILLS_MODAL, handleModalOpen);
  }, []);

  const handleClose = () => {
    handleModalClose();
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleClose}
      ariaHideApp={false}
      overlayClassName="bills-included-modal__overlay"
    >
      <ModalHeader
        titleClassName="bills-included-modal__title"
        label={trans('listing.bills.modal.title')}
        className="bills-included-modal__content"
        onRequestClose={handleClose}
      />
      <ModalBody className="bills-included-modal__content">
        <ListingBills
          showTitle={false}
          bills={bills}
          currency={currency}
          listingType={listingType}
        />
      </ModalBody>
    </Modal>
  );
};

BillsIncludedModal.propTypes = {
  bills: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
      additionalInfo: PropTypes.number
    })
  ),
  currency: PropTypes.string.isRequired,
  listingType: PropTypes.string.isRequired
};

export default BillsIncludedModal;
